import { prop, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";

export class CaseFileCategory extends Resource {
    public override type = 'caseFileCategories';

    @prop()
    @required()
    public name!: string;

    @prop()
    @required()
    public showInMobile: boolean = true;
}